import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import Footer from '@/components/Footer';

export const Route = createFileRoute('/blog')({
  component: BlogLayout,
});

function BlogLayout() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <header className="border-b border-gray-800 py-6 px-6">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-2xl font-['Pacifico'] text-white">
            AITOS
          </Link>
          <Link to="/blog" className="text-gray-400 hover:text-white transition-colors">
            Blog
          </Link>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-12 flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
